import MutationSummary from 'mutation-summary';

let DomSerializer = (function () {

  function DomSerializer() {
    this.nextId = 1;
    this.knownNodes = new Map();
  }

  DomSerializer.prototype._serializeNodeChildren = function (node) {
    let children = [];
    for (var child = node.firstChild; child; child = child.nextSibling) {
      children.push(this._serializeNode(child, true));
    }
    children = children.filter(c => c !== null);
    return children;
  }

  DomSerializer.prototype._serializeNode = function (node, recursive) {
    if (node === null) {
      return null;
    }
    let nodeId = this.knownNodes.get(node);
    if (nodeId !== undefined) {
      return { id: nodeId };
    }
    nodeId = this.nextId;
    this.nextId++;
    this.knownNodes.set(node, nodeId);
    let retval = null;
    switch (node.nodeType) {
      case Node.COMMENT_NODE:
      case Node.TEXT_NODE:
        retval = {
          id: nodeId,
          nodeType: node.nodeType,
          textContent: node.textContent
        };
        break;
      case Node.ELEMENT_NODE:
        retval = {
          id: nodeId,
          nodeType: node.nodeType,
          tagName: node.tagName,
          attributes: {},
        };
        for (var i = 0; i < node.attributes.length; i++) {
          let attr = node.attributes[i];
          retval.attributes[attr.name] = attr.value;
        }
        if (recursive && node.childNodes.length) {
          retval.childNodes = this._serializeNodeChildren(node);
        }
        break;
    }
    return retval;
  }

  DomSerializer.prototype._serializeAttributeChanges = function (attributeChanged) {
    let map = new Map();
    for (let attributeName of Object.keys(attributeChanged)) {
      for (let element of attributeChanged[attributeName]) {
        let record = map.get(element);
        if (!record) {
          record = this._serializeNode(element);
          record.attributes = {};
          map.set(element, record);
        }
        record.attributes[attributeName] = element.getAttribute(attributeName);
      }
    }
    return Array.from(map.values());
  };

  DomSerializer.prototype._serializeAddedAndMoved = function (added, reparented, reordered) {
    let all = added.concat(reparented).concat(reordered);
    let parentMap = new Map();
    for (let node of all) {
      let parent = node.parentNode;
      let children = parentMap.get(parent);
      if (!children) {
        children = new Map();
        parentMap.set(parent, children);
      }
      children.set(node, true);
    }
    let moved = [];
    for (let parent of parentMap.keys()) {
      let children = parentMap.get(parent);
      while (children.size > 0) {
        let node = children.keys().next().value;
        while (node.previousSibling && children.has(node.previousSibling)) {
          node = node.previousSibling;
        }
        while (node && children.has(node)) {
          let data = this._serializeNode(node);
          data.previousSibling = this._serializeNode(node.previousSibling);
          data.parentNode = this._serializeNode(node.parentNode);
          moved.push(data);
          children.delete(node);
          node = node.nextSibling;
        }
      }
    }
    return moved;
  };

  DomSerializer.prototype.serializeDocument = function (document) {
    // we serialize the HTML node and all its children
    let root = this._serializeNode(document.childNodes[1], true);
    root.base = document.baseURI;
    return root;
  }
  DomSerializer.prototype.serializeMutationSummary = function (summary) {
    let removed = summary.removed.map(node => this._serializeNode(node));
    let moved = this._serializeAddedAndMoved(summary.added, summary.reparented, summary.reordered);
    let attributes = this._serializeAttributeChanges(summary.attributeChanged);
    let text = summary.characterDataChanged.map(node => this._serializeNode(node));
    for (let node of summary.removed) {
      this.knownNodes.delete(node);
    };

    return {
      removed: removed,
      addedOrMoved: moved,
      attributes: attributes,
      text: text
    };
  }

  return DomSerializer;
})();

trackerSetupRun.$inject = ['$window', '$rootScope', 'XHRStatsFactory'];
export function trackerSetupRun($window, $rootScope, XHRStatsFactory) {

  let domSerializer = null;
  $rootScope.$on("ws.user.dom-track-start", function (event) {
    if (domSerializer !== null) {
      return;
    }
    domSerializer = new DomSerializer();
    XHRStatsFactory.onDomInitialize(domSerializer.serializeDocument($window.document));
    let observer = new MutationSummary({
      queries: [{ all: true }],
      callback: function (summaries) {
        try {
          let summary = summaries[0];
          let data = domSerializer.serializeMutationSummary(summary);
          XHRStatsFactory.onDomChange(data);
        } catch (e) {
          console.error(e);
        }
      }
    });
  });

  if ($window.hasOwnProperty("performance")) {
    if ($window.hasOwnProperty("PerformanceObserver")) {
      let observer = new PerformanceObserver((l, o) => XHRStatsFactory.onPerformanceEntries(l.getEntries()));
      observer.observe({ entryTypes: ["resource"] });
    }
  }

  $window.addEventListener('online', function () {
    try { XHRStatsFactory.onOnLine(); } catch (e) { console.error(e); }
  });

  $window.addEventListener('offline', function () {
    try { XHRStatsFactory.onOffLine(); } catch (e) { console.error(e); }
  });


  // $window.addEventListener('mouseover', function(mouseEvent) {
  //   try {XHRStatsFactory.onMouseOver(mouseEvent);} catch (e) {console.error(e);}
  // });
  $window.addEventListener('click', function (mouseEvent) {
    try { XHRStatsFactory.onClick(mouseEvent); } catch (e) { console.error(e); }
  });
  $window.addEventListener('touchstart', function (touchEvent) {
    try { XHRStatsFactory.onTouchStartOrEnd(touchEvent); } catch (e) { console.error(e); }
  });
  $window.addEventListener('touchend', function (touchEvent) {
    try { XHRStatsFactory.onTouchStartOrEnd(touchEvent); } catch (e) { console.error(e); }
  });
  $window.addEventListener('keyup', function (keyboardEvent) {
    try { XHRStatsFactory.onKeyUp(keyboardEvent); } catch (e) { console.error(e); }
  });
  $window.addEventListener('resize', function () {
    try { XHRStatsFactory.onResize(); } catch (e) { console.error(e); }
  });
  $window.addEventListener("error", function (error) {
    try { XHRStatsFactory.onError(error); } catch (e) { console.error(e); }
  });
  $window.addEventListener("unhandledrejection", function (exception) {
    try { XHRStatsFactory.onUnhandledrejection(exception); } catch (e) { console.error(e); }
  });

  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    try { XHRStatsFactory.onStateChangeStart(toState, toParams, fromState, fromParams); } catch (e) { console.error(e); }
  });
  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
    try { XHRStatsFactory.onStateChangeSuccess(toState, toParams, fromState, fromParams); } catch (e) { console.error(e); }
  });
  $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
    try { XHRStatsFactory.onStateChangeError(toState, toParams, fromState, fromParams, error); } catch (e) { console.error(e); }
  });
}


